/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const CLOCK_PATH =
  'M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10 18.3333C5.3975 18.3333 1.66667 14.6025 1.66667 10C1.66667 5.3975 5.3975 1.66667 10 1.66667C14.6025 1.66667 18.3333 5.3975 18.3333 10C18.3333 14.6025 14.6025 18.3333 10 18.3333ZM10.8333 5.83333C10.8333 5.3731 10.4602 5 10 5C9.53977 5 9.16667 5.3731 9.16667 5.83333V10.4167C9.16667 10.6558 9.26161 10.885 9.43018 11.0536L12.2635 13.8869C12.587 14.2104 13.1129 14.2104 13.4364 13.8869C13.7599 13.5634 13.7599 13.0375 13.4364 12.714L10.8333 10.1109V5.83333Z';

const ClockIcon = ({
  size = 20,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={CLOCK_PATH} fill="currentColor" />
  </svg>
);

ClockIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default ClockIcon;
